export class ZoomLevels {
    constructor(groups) {
        this.groups = groups;
    }
    getGroupIndex(zoom) {
        if (zoom == null)
            return null;
        for (let i = 0; i < this.groups.length - 1; i++) {
            if (zoom < this.groups[i + 1].min)
                return i;
        }
        return this.groups.length - 1;
    }
    get(index) {
        return this.groups[index];
    }
    getForZoom(zoom) {
        return this.groups[this.getGroupIndex(zoom)];
    }
}
(function (ZoomLevels) {
    ZoomLevels.none = new ZoomLevels([
        { min: -1000, value: null }
    ]);
})(ZoomLevels || (ZoomLevels = {}));
export class FloorLevels {
    constructor(groups) {
        this.groups = groups;
    }
    getGroupIndex(floor) {
        return this.groups.findIndex(g => g.floors.includes(floor));
    }
    get(index) {
        return this.groups[index];
    }
}
(function (FloorLevels) {
    FloorLevels.none = new FloorLevels([{ floors: [0, 1, 2, 3], value: null }]);
    function single(floor, value = undefined) {
        return new FloorLevels([
            { floors: [floor], value: value },
            { floors: [0, 1, 2, 3], hidden_here: true },
        ]);
    }
    FloorLevels.single = single;
    function special(floor) {
        return new FloorLevels([
            { floors: [floor], value: { correct_level: true } },
            { floors: [0, 1, 2, 3], value: { correct_level: false } },
        ]);
    }
    FloorLevels.special = special;
})(FloorLevels || (FloorLevels = {}));
